import { useState } from 'react';
import { getUserPaidLocalCars } from '../../services/orderService';

const useGetPaidLocalCars = () => {
  const [paidLocal, setPaidLocal] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchPaidLocalCars = async () => {
    setLoading(true);
    try {
      const resp = await getUserPaidLocalCars();
      setPaidLocal(resp);
    } catch (err) {
      if (err.response) {
        setError(`${err.response.data.message || 'No response from server'}`);
      } else if (err.request) {
        setError('No response from server');
      } else {
        setError(`${err.message}`);
      }
    } finally {
      setLoading(false);
    }
  };

  return { paidLocal, loading, error, fetchPaidLocalCars };
};

export default useGetPaidLocalCars;



